import { SERPFlightSector } from "../types/serpResult";

export const extractAirlines = (sectors: SERPFlightSector[]): string[] => {
  const departureSector = sectors[0];
  const returnSector = sectors[1];

  const airlines = new Set<string>();

  departureSector && airlines.add(departureSector.airline);

  returnSector && airlines.add(returnSector.airline);

  return Array.from(airlines);
};
